module.exports = __webpack_public_path__ + "img/assess-icon.2ee0eb21.svg";